import React, { PureComponent } from 'react';
import { Form, Field } from 'react-final-form';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { composeValidators } from '../../../utils/helper';
import { required } from '../../../utils/validation';
import BootstrapSuccessError from './BootstrapSuccessError';
import LKModal from '../Modal/Modal';
import VoucherDetail from './VoucherDetail';
import { checkVoucherBalance, clearState } from '../../../actionCreators/myAccount';
import { validateSpecialCharsAddress } from '../../../utils/validation';

class CheckVoucher extends PureComponent {
  constructor(props) {
    super(props);
    const {
      dataLocale: { OOPS_SOMETHING_WENT_WRONG },
    } = props;
    this.onCheckVoucherSubmit = this.onCheckVoucherSubmit.bind(this);
    this.close = this.close.bind(this);
    this.voucherResultMessage = OOPS_SOMETHING_WENT_WRONG;
  }
  componentDidMount() {
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnLoad({
        pagename: 'check gift voucher balance',
        satellite: 'account',
        subSection1: 'check gift voucher balance',
      });
    }
  }
  componentWillUnmount() {
    this.close();
  }

  onCheckVoucherSubmit({ checkBalance }) {
    this.props.checkVoucherBalance(checkBalance);
    if (window.dtm.LenskartRewamp && window.dtm.LenskartRewamp.myaccount) {
      window.dtm.LenskartRewamp.myaccount.OnClick({
        linkPageName: 'check store credit balance',
        linkName: 'check store credit balance',
        giftVoucherCode: checkBalance,
        clickEvent: 'onClick',
        satellite: 'generic-int-link',
      });
    }
  }

  close() {
    this.props.clearState({ voucherResult: null });
  }

  render() {
    const { loading, voucherResult, dataLocale } = this.props;
    let type = '';
    if (voucherResult && (voucherResult.error || voucherResult.errors)) {
      type = 'error';
    }
    const {
      CHECK_GIFT_VOUCHER_BALANCE,
      ENTER_YOUR_VOUCHER_CODE,
      CHECK_VOUCHER_BALANCE,
      CHECK_BALANCE,
      GIFT_VOUCHER_CODE,
    } = dataLocale;
    return (
      <div className="display-flex flex-column">
        <Helmet title={CHECK_GIFT_VOUCHER_BALANCE} />
        <h2>{CHECK_VOUCHER_BALANCE}</h2>
        {Boolean(voucherResult && (voucherResult.error || voucherResult.errors) && !loading) && (
          <BootstrapSuccessError
            message={voucherResult.message || this.voucherResultMessage}
            type={type}
          />
        )}
        <Form
          noValidate
          autoComplete="off"
          autoCorrect="off"
          render={({ handleSubmit }) => {
            return (
              <form className="form-SLA" onSubmit={handleSubmit}>
                <div className="form-group" style={{ width: '25%' }}>
                  <Field
                    name="checkBalance"
                    validate={composeValidators(
                      required,
                      validateSpecialCharsAddress(ENTER_YOUR_VOUCHER_CODE)
                    )}
                  >
                    {({ input, meta }) => (
                      <div className={meta.touched && meta.error ? 'has-error' : ''}>
                        <label className="control-label">{ENTER_YOUR_VOUCHER_CODE}*</label>
                        <input className="form-control" {...input} autoComplete="off" type="text" />
                        {meta.touched && meta.error && (
                          <div className="help-block with-errors">{meta.error}</div>
                        )}
                      </div>
                    )}
                  </Field>
                </div>
                <div
                  className="padding-t20 col-sm-8 padding-l0"
                  style={{ borderTop: '1px dashed #ccc' }}
                >
                  <button
                    className="btn-submit btn btn-primary col-sm-4 uppercase"
                    disabled={loading}
                    type="submit"
                  >
                    {CHECK_BALANCE}{' '}
                  </button>
                </div>
              </form>
            );
          }}
          onSubmit={this.onCheckVoucherSubmit}
        />
        <LKModal
          keyboard
          backdrop="static"
          dialogClassName="voucher-detail"
          headerTitle={GIFT_VOUCHER_CODE}
          hideHandler={this.close}
          showModal={Boolean(voucherResult && voucherResult.result)}
          size="large"
        >
          {Boolean(voucherResult && voucherResult.result) && (
            <VoucherDetail
              close={this.close}
              dataLocale={dataLocale}
              voucherCode={{ title: GIFT_VOUCHER_CODE, code: voucherResult.result.giftVoucherCode }}
              voucherDetails={voucherResult.result}
            />
          )}
        </LKModal>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loading: state.myAccount.loading,
  voucherResult: state.myAccount.voucherResult,
  dataLocale: state.locale,
});

function mapDispatchToProps(dispatch) {
  return {
    checkVoucherBalance: value => dispatch(checkVoucherBalance(value)),
    clearState: value => dispatch(clearState(value)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CheckVoucher);
